module.exports = __webpack_public_path__ + "img/Bear42.fea7f93b.jpg";